
export default function CaretRight({fill = "#191936"}) {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.13152 6.35898L0.310523 10.18C-0.103477 10.594 -0.103477 11.266 0.310523 11.68C0.724524 12.094 1.39652 12.094 1.81052 11.68L6.42452 7.06598C6.81552 6.67498 6.81552 6.04198 6.42452 5.65198L1.81052 1.03798C1.39652 0.623979 0.724523 0.623979 0.310523 1.03798C-0.103477 1.45198 -0.103477 2.12398 0.310523 2.53798L4.13152 6.35898Z" fill={fill} />
    </svg>
  )
}

